export default {
  title: {
    employeeManagement: '员工管理'
  },
  menu: '员工管理',
  label: {
    name: '姓名',
    validationInfo: '有效信息',
    email: '邮箱地址',
    updateTime: '更新时间',
    checkAll: '全选',
    pending: '待定',
    approve: '同意',
    reject: '拒绝',
    resign: '离职',
    approved: '已审核',
    rejected: '已拒绝',
    resigned: '已离职',
    unregistered: '待注册',
    statusAll: '全部',
    registerCheck: '启用员工注册验证',
    setupEmailDomain: '设置邮箱域名',
    updateEmployeeStatus: '批量修改员工状态',
    emailDomain: '邮箱域名：',
    pinCode: '公司邀请码：{companyPinCode}',
    basicInfoTitle: '基本信息',
    allTotal: '总员工：{allTotal}',
    downloadEmployee: '下载所有员工',
    uploadEmployee: 'EXCEL文件:',
    emailSuffixTitle: '输入公司邮箱的域名，如果有多于一个，请用“|”分隔。',
    emailSuffixContent: '例如：如果您的公司邮箱为abc@def.com，那么对应的公司邮箱域名为def.com',
    employeeStatusTip: '你确定将员工状态改为“{status}”？',
    companyName: '公司名称',
    operation: '操作',
    rows: '行 {row}：',
    batchUploadResult: '批量更新结果',
    uploadCount: '上传总数：{total}',
    updateCount: '更新数：{total}',
    waitRegisterCount: '待注册数：{total}',
    failCount: '失败数：{total}',
    detail: '详细记录',
    invalidStatus: '错误的状态：{status}',
    notFound: '没有员工与邮箱对应：{code}',
    hasUsed: '员工工号已被注册成其他账号：{email}',
    noRegister: '未启用员工注册验证：{email}',
    noEmail: '邮箱为空注册失败：{email}',
    duplicateEmail: '邮箱在文件中已存在：{email}'

  },
  placeholder: {
    search: '搜索（邮箱/有效信息/姓名）'
  },
  btn: {
    approve: '同意',
    reject: '拒绝',
    resign: '离职',
    pending: '待定',
    upload: '浏览'
  },
  message: {
    uploadTip: '只能上传excel文件',
    uploadError: '上传失败,请重新上传',
    optionSuccess: '操作成功',
    optionField: '操作失败',
    uploadType: '请确认上传的文件以此类后缀结尾 .xls .xlsx',
    emailSuffixValidate: "含有不合法的字符，输入内容只能是字母、数字、'.'、'-' 和 '|'。"
  }
}
